import { render, staticRenderFns } from "./AddCollectionModal.vue?vue&type=template&id=01aa877a&scoped=true&"
import script from "./AddCollectionModal.vue?vue&type=script&lang=js&"
export * from "./AddCollectionModal.vue?vue&type=script&lang=js&"
import style0 from "./AddCollectionModal.vue?vue&type=style&index=0&id=01aa877a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aa877a",
  null
  
)

export default component.exports